import script from "./NimbusButton.vue?vue&type=script&setup=true&lang=js"
export * from "./NimbusButton.vue?vue&type=script&setup=true&lang=js"

import "./NimbusButton.vue?vue&type=style&index=0&id=3bb38e06&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb38e06"]])

export default __exports__